const preloadImage = async (path) => {
	if (!path) return null

	return new Promise((resolve) => {
		const img = new Image()
		img.crossOrigin = 'anonymous' // optionally handle CORS

		img.onload = async () => {
			try {
				await img.decode() // decode safely
				resolve(img.src)
			} catch (error) {
				console.error('Image decode failed:', error, path)
				resolve(null) // or fallback path
			}
		}

		img.onerror = (err) => {
			console.error('Image failed to load:', err, path)
			resolve(null)
		}

		img.src = path
	})
}

export default preloadImage
